import useLocalStorage from "hooks/useLocalStorage";
import { createContext } from "react";
import { THEMES } from "../constants";

const getSystemTheme = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches ? THEMES.DARK : THEMES.LIGHT;

const initialSettings = {
  activeLayout: "layout3",
  direction: "ltr",
  theme: getSystemTheme(),
  // "system": theme should keep tracking the OS preference (see below).
  // "user": the user explicitly picked a theme via the toggle; always respected.
  themeSource: "system",
  responsiveFontSizes: true,
};

export const SettingsContext = createContext({
  settings: initialSettings,
  saveSettings: () => {},
}); // component props type

const SettingsProvider = ({ children }) => {
  const { data: storedSettings, storeData: setStoreSettings } = useLocalStorage(
    "settings",
    initialSettings
  );

  // Settings that aren't an explicit user choice (themeSource !== "user") always
  // re-derive theme from the current OS preference rather than replaying whatever
  // was persisted. This also self-heals any stale "dark" value stored before the
  // matchMedia(...).matches fix, since old entries have no themeSource field.
  const settings =
    storedSettings.themeSource === "user"
      ? storedSettings
      : { ...storedSettings, theme: getSystemTheme(), themeSource: "system" };

  const saveSettings = (updateSettings) => {
    setStoreSettings(updateSettings);
  };

  return (
    <SettingsContext.Provider
      value={{
        settings,
        saveSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsProvider;
